// extracted by mini-css-extract-plugin
module.exports = {"clickableChip":"styles_clickableChip__1kAww","chip":"styles_chip__Ms5P7","visuallyHidden":"styles_visuallyHidden__1ocQQ"};